import SyncOutlined from '@mui/icons-material/SyncOutlined';
import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Cross-tab banner shown above the report while a saved settings change is
 * queued for the next nightly run — the data below still reflects the previous
 * settings. Report-level: driven by the Guest Journey job status
 * `settingsProcessing`.
 */
const GuestJourneySettingsProcessingBanner = () => {
  const { t } = useTranslation();

  return (
    <Alert
      severity="info"
      icon={<SyncOutlined />}
      data-testid="GuestJourney.SettingsProcessing"
    >
      <AlertTitle>{t('page.guestJourney.settingsProcessing.title')}</AlertTitle>
      {t('page.guestJourney.settingsProcessing.text')}
    </Alert>
  );
};

export default GuestJourneySettingsProcessingBanner;
